
// Environment configuration
const isDevelopment = import.meta.env.DEV;

// API configuration
const API_URL = import.meta.env.VITE_API_URL || "https://api-6opi2zac6q-uc.a.run.app";

// Firebase configuration
const FCM_VAPID_KEY = "BGRiF-Isy2GgGlpv8TWJc6sOs8wSMvGcbnffgRHzWYzrSl-XOSKaEWNWEgWbTQQ6WTZ2OEMysRf5Zi4J8KAQdQQ";

// Standard reCAPTCHA key for Firebase phone auth
const RECAPTCHA_SITE_KEY = "6LeSfAErAAAAAAwchgA9OTAKMFnmB3Qz1biLgft2";

// WhatsApp support number
const WHATSAPP_SUPPORT_NUMBER = "972505044604";

// Solo mostrar logs en entorno de desarrollo
if (isDevelopment) {
  console.log("Environment configuration loaded:");
  console.log("- API URL:", API_URL);
  console.log("- reCAPTCHA site key:", RECAPTCHA_SITE_KEY);
  console.log("- WhatsApp support number:", WHATSAPP_SUPPORT_NUMBER);
}

export const config = {
  api: {
    baseUrl: API_URL,
    endpoints: {
      health: "/health",
      createSession: "/sessions/create",
      updateSession: (id: string) => `/sessions/${id}`,
      deleteSession: (id: string) => `/sessions/${id}`,
      reconnectSession: (id: string) => `/sessions/${id}/reconnect`,
      sessionEvents: (id: string) => `/sessions/${id}/events/sse`,
      getConversations: (id: string) => `/sessions/${id}/conversations`,
      getMessages: (sessionId: string, conversationId: string) => 
        `/sessions/${sessionId}/conversations/${conversationId}/messages`,
    }
  },
  firebase: {
    fcm: {
      vapidKey: FCM_VAPID_KEY
    },
    recaptcha: {
      siteKey: RECAPTCHA_SITE_KEY
    }
  },
  whatsapp: {
    supportNumber: WHATSAPP_SUPPORT_NUMBER
  },
  isDevelopment
};
